/**
 * Shared header config for authenticated pages.
 * Used by AuthenticatedHeader and MobilePageTitle (body title on mobile).
 */
import i18n from 'i18next';

export interface AuthenticatedHeaderConfig {
  title: string;
  subtitle: string;
  showUserInfo: boolean;
  showBalance: boolean;
  useRightSlot: boolean;
  /** When false, hide the back button (e.g. on Account Hub). */
  back?: boolean;
  backTo?: string;
}

export function getAuthenticatedHeaderConfig(path: string): AuthenticatedHeaderConfig {
  if (path.includes('/account/finance/payment-checkout')) {
    return {
      title: i18n.t('pageTitles.paymentCheckout'),
      subtitle: i18n.t('pageSubtitles.completeDepositPayment'),
      showUserInfo: false,
      showBalance: false,
      useRightSlot: false,
      backTo: '/account/finance/deposit',
    };
  }

  if (path.includes('/account/finance/deposit')) {
    return {
      title: i18n.t('pageTitles.deposit'),
      subtitle: i18n.t('header.selectPlatformsToDeposit'),
      showUserInfo: true,
      showBalance: true,
      useRightSlot: false,
      backTo: '/account',
    };
  }

  if (path.includes('/account/finance/withdrawals')) {
    return {
      title: i18n.t('pageTitles.withdraw'),
      subtitle: i18n.t('pageSubtitles.selectGamesAndAmountToWithdraw'),
      showUserInfo: true,
      showBalance: true,
      useRightSlot: false,
    };
  }

  if (path.includes('/account/wallet/deposit-checkout')) {
    return {
      title: i18n.t('pageTitles.walletDepositCheckout'),
      subtitle: i18n.t('pageSubtitles.addFundsToWallet'),
      showUserInfo: false,
      showBalance: false,
      useRightSlot: false,
      backTo: '/account/finance/wallet',
    };
  }

  if (path.includes('/account/wallet/payout-request')) {
    return {
      title: i18n.t('pageTitles.walletPayoutRequest'),
      subtitle: i18n.t('pageSubtitles.requestPayoutFromWallet'),
      showUserInfo: false,
      showBalance: false,
      useRightSlot: false,
      backTo: '/account/finance/wallet',
    };
  }

  if (path.includes('/account/finance/wallet')) {
    return {
      title: i18n.t('pageTitles.myWallet'),
      subtitle: i18n.t('pageSubtitles.manageWalletBalance'),
      showUserInfo: true,
      showBalance: true,
      useRightSlot: false,
      backTo: '/account',
    };
  }

  if (path.includes('/account/settings')) {
    return {
      title: i18n.t('pageTitles.accountSettings'),
      subtitle: i18n.t('pageSubtitles.managePersonalInformation'),
      showUserInfo: true,
      showBalance: false,
      useRightSlot: true,
      backTo: '/account',
    };
  }

  if (path.includes('/account/games')) {
    return {
      title: i18n.t('pageTitles.gameManagement'),
      subtitle: i18n.t('pageSubtitles.manageGameAccountsAndBalances'),
      showUserInfo: true,
      showBalance: true,
      useRightSlot: false,
    };
  }

  if (path.includes('/account/transactions')) {
    return {
      title: i18n.t('pageTitles.transactionHistory'),
      subtitle: i18n.t('pageSubtitles.viewAllTransactions'),
      showUserInfo: true,
      showBalance: true,
      useRightSlot: false,
    };
  }

  return {
    title: i18n.t('header.accountHub'),
    subtitle: i18n.t('header.yourLuckyGamingPortal'),
    showUserInfo: true,
    showBalance: true,
    useRightSlot: false,
    back: false,
  };
}
